import './games-filters'
import './games-shortcode'
import './slider-home'
import './tabs'
import './parallax'
import './sections'
import './scroll-top'
import './modal'
import './game-gallery'